module.exports = __webpack_public_path__ + "static/media/WBN_B2B_Manufacturers_Buyers_Distributors_Exporters_Importers_United Kingdom.0bf8d8c5.png";